import axios from "axios";
import {API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};
 
export const GetTrafficMarshal = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `TrafficMarshal/GetAllTrafficMarshal`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetOperationTypes = async () => {
    try {
      const response = await axiosInstance.get(API_BASE_URL1 + `TrafficMarshal/GetOperationTypes`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

export const UpdateTrafficMarshalDetails = async (circleData) => {
    try {
      const response = await axiosInstance.put(API_BASE_URL1 + `TrafficMarshal/UpdateTrafficMarshalDetails`, circleData,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          },
   
        });
   
      //console.log(response.data, 'circle update')
     
      return response;
    } catch (error) {
          throw error
     
    }
  };


  export const CreateTrafficMarshalDeatails = async (zoneData) => {
    try {
      const response = await axiosInstance.post(API_BASE_URL1 + `TrafficMarshal/AddTrafficMarshalDetails`, zoneData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
          },
   
        });
      return response;
    } catch (error) {
          throw error;
     
    }
  };
   